export interface LoaderState {
  show: boolean;
  width: number;
  time: number;
}
